import { useTranslation } from 'react-i18next'
import { Newspaper } from 'lucide-react'

import { targetingType, type TargetingTypeId } from '@/services/targeting/targeting'

export interface TargetPaneProps {
  /** A targeting type, or the combined inventory browser. */
  type: TargetingTypeId | 'inventory'
  children: React.ReactNode
  /** Rendered to the right of the title, e.g. a "Remove all" button. */
  actions?: React.ReactNode
}

/** Title, icon and explanation above one targeting type's editor. */
export function TargetPane({ type, children, actions }: TargetPaneProps) {
  const { t } = useTranslation()
  const Icon = type === 'inventory' ? Newspaper : targetingType(type).icon
  const title =
    type === 'inventory' ? t('targeting.inventory.title') : t(`targeting.types.${type}.plural`)
  const help =
    type === 'inventory' ? t('targeting.inventory.help') : t(`targeting.types.${type}.help`)

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
          <h3 className="flex items-center gap-2 text-sm font-semibold">
            <Icon className="size-4 text-muted-foreground" />
            {title}
          </h3>
          <p className="text-xs text-muted-foreground">{help}</p>
        </div>
        {actions && <div className="shrink-0">{actions}</div>}
      </div>
      {children}
    </div>
  )
}
